var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_2 = require("react");
const KEY = `gatsby-plugin-themes-theme-index`;
exports.ThemeContext = react_2.createContext({
    theme: {},
    next: () => undefined,
});
const supportsDarkMode = () => window.matchMedia("(prefers-color-scheme: dark)").matches;
exports.ThemeProvider = props => {
    const { themes, children } = props;
    const _themes = Array.isArray(themes) ? themes : [themes];
    const [themeIndex, setThemeIndex] = react_2.useState(0);
    const theme = _themes[themeIndex % _themes.length];
    const setTheme = index => {
        const i = index % _themes.length;
        localStorage.setItem(KEY, `${i}`);
        setThemeIndex(i);
    };
    const next = () => {
        setTheme(themeIndex + 1);
    };
    react_2.useEffect(() => {
        const localThemeIndex = Number(localStorage.getItem(KEY));
        if (localThemeIndex !== NaN) {
            setTheme(localThemeIndex);
        }
        else if (supportsDarkMode()) {
            setTheme(Math.max(_themes.findIndex(t => t.dark), 0));
        }
    }, []);
    return (react_1.default.createElement(exports.ThemeContext.Provider, { value: {
            theme,
            next,
        } }, children));
};
//# sourceMappingURL=context.js.map